import createEmotionServer from '@emotion/server/create-instance';
import { classNamePrefix, getEmotionInstance } from '@gs-ux-uitoolkit-common/style';
/**
 * Used internally for SSR (server-side rendering), extracts the "critical CSS"
 * (i.e. the styles required by a server-side rendered HTML snippet) and returns
 * the data needed to render a static `<style>` tag from it.
 *
 * @private
 */
export function extractCriticalStyles(html) {
    const cache = getEmotionInstance().cache;
    const { extractCritical } = createEmotionServer(cache);
    return {
        key: classNamePrefix,
        ...extractCritical(html),
    };
}
//# sourceMappingURL=extract-critical-styles.js.map